import ArticleNinePage from './containers/ArticleNineContainer'

export default store => {
  return {
    path: '9',
    exact: true,
    getComponent(nextState, cb) {
      require.ensure([], () => {
        cb(null, ArticleNinePage, 'articles')
      })
    },
  }
}
